// services/index.ts
// Consolidates all frontend service exports into a single file

// Note: Using direct fetch since OpenAPI config is handled per API instance in new generator

import { XeroService } from '../../client'

// Re-export core client functionality
export { ApiError } from '../../client/core/ApiError'
export {
  CancelablePromise,
  CancelError,
} from '../../client/core/CancelablePromise'
export type { OpenAPIConfig } from '../../client/core/OpenAPI'
export { OpenAPI } from '../../client/core/OpenAPI'
// Re-export types and models from client for convenience
export * from '../../client/models'
export * from '../../client/schemas'
// Export new API wrappers
export * from './ApiWrappers'
// Re-export everything from ChartDataService
export * from './ChartDataService'

// XeroApi Types
export interface XeroStatus {
  configured: boolean
  tenant_id?: string
  expires_at?: string
  updated_at?: string
  has_refresh_token?: boolean
  error?: string
}

// XeroApi Implementation (legacy object-based API)
export const XeroApiLegacy = {
  /**
   * Check the status of Xero authentication
   */
  getStatus: async (): Promise<XeroStatus> => {
    return (await XeroService.xeroStatus()) as unknown as XeroStatus
  },

  /**
   * Initiate Xero login flow
   * This will redirect the user to Xero's authentication page
   */
  login: () => {
    window.location.href = '/api/v1/xero/login'
  },
}
